module["exports"] = [
  "####",
  "###",
  "##",
  "#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/address/building_number.js
// module id = 1485
// module chunks = 0